var map = {
	"./american-express.svg": 1789,
	"./apple-pay.svg": 1345,
	"./diners.svg": 4287,
	"./discover.svg": 6817,
	"./google-pay.svg": 8268,
	"./jcb.svg": 4345,
	"./klarna.svg": 3903,
	"./maestro.svg": 2883,
	"./mastercard.svg": 9384,
	"./paypal.svg": 7025,
	"./unionpay.svg": 321,
	"./visa.svg": 1851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6214;